import styled from '@emotion/styled';

export const SadaServiceCalendarForm = styled.div``;
